import React from 'react';

const uniq = (arr) => [...new Set(arr.filter(Boolean))];

const Chip = ({ label, active, disabled, onClick, testid, large }) => (
  <button type="button" onClick={onClick} disabled={disabled} data-testid={testid}
    className={`${large ? 'min-h-[44px] min-w-[44px] px-4 rounded-full text-sm' : 'px-3 py-1.5 rounded-lg text-sm'} border font-medium transition-colors ${
      active ? 'border-zl-orange bg-orange-50 text-zl-orange ring-1 ring-zl-orange'
        : disabled ? 'border-gray-200 bg-gray-50 text-gray-300 line-through cursor-not-allowed'
        : 'border-gray-200 bg-white text-gray-700 hover:border-gray-400'
    } ${large ? '' : 'border-2'}`}>
    {label}
  </button>
);

const findVariant = (variants, size, color) =>
  variants.find(v => (v.size || '') === (size || '') && (v.color || '') === (color || ''));

export const VariantSelector = ({ variants, selected, onSelect, large = false, testidPrefix = "variant" }) => {
  const sizes = uniq(variants.map(v => v.size));
  const colors = uniq(variants.map(v => v.color));
  const size = selected?.size || '';
  const color = selected?.color || '';

  const pick = (dim, value) => {
    const exact = findVariant(variants, dim === 'size' ? value : size, dim === 'color' ? value : color);
    const sameDim = variants.filter(v => v[dim] === value);
    onSelect(exact || sameDim.find(v => Number(v.stock) > 0) || sameDim[0] || null);
  };

  const available = (s, c) => variants.some(v => (!s || v.size === s) && (!c || v.color === c) && Number(v.stock) > 0);

  return (
    <div className="space-y-3 mb-4" data-testid="variant-selector">
      {sizes.length > 0 && (
        <div>
          <p className="text-sm text-gray-600 mb-1.5">Talla: <span className="font-semibold text-gray-900">{size || 'Elige una'}</span></p>
          <div className="flex flex-wrap gap-2">
            {sizes.map(s => (
              <Chip key={s} label={s} active={s === size} disabled={!available(s, colors.length ? color : '')}
                onClick={() => pick('size', s)} testid={`${testidPrefix}-size-option-${s}`} large={large} />
            ))}
          </div>
        </div>
      )}
      {colors.length > 0 && (
        <div>
          <p className="text-sm text-gray-600 mb-1.5">Color: <span className="font-semibold text-gray-900">{color || 'Elige uno'}</span></p>
          <div className="flex flex-wrap gap-2">
            {colors.map(c => (
              <Chip key={c} label={c} active={c === color} disabled={!available(sizes.length ? size : '', c)}
                onClick={() => pick('color', c)} testid={`${testidPrefix}-color-option-${c}`} large={large} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
